<template>
    <div>
        <span v-if="label" :class="['label', {'bolder': bolderLabel}]">{{ label }}</span>
        <v-text-field
            autocomplete="off"
            :autofocus="autofocus"
            :color="color"
            :value="defaultValue"
            @input="onChange"
            @click:clear="model = ''"
            @keyup.enter.prevent="$event.target.blur()"
            @keypress.enter.prevent="$event.target.blur()"
            @blur="$emit('blur')"
            @keypress="isNumber($event)"
            :placeholder="placeholder"
            :rules="rules"
            :prefix="prefix"
            :suffix="suffix"
            :dense="dense"
            :clearable="clearable"
            :inputmode="inputMode"
            :loading="loading"
            hide-details
            :solo="solo"
            flat
            :class="[{'centered-input': centeredValue},{'kimsa-elevation': !noElevation}]"
            @click:append="$emit('click:append')"
            :append-icon="icon"
            :prepend-icon="prependIcon"
            :prepend-inner-icon="prependInnerIcon"
            :maxlength="maxLength"
            :disabled="disabled"
            :readonly="readonly"
        >
            <template v-slot:prepend-inner>
                <slot name="prepend-inner"></slot>
            </template>
            <template v-slot:append>
                <slot name="append"></slot>
            </template>
        </v-text-field>
    </div>

</template>

<script>
export default {
    name: "KimsaTextField",
    props: {
        outlined: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        inputMode: {
            type: String,
            default: 'text'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: ''
        },
        suffix: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: 'secondary'
        },
        rules: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number],
            default: '',
        },
        noElevation: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: '',
        },
        prependIcon: {
            type: String,
            default: ''
        },
        prependInnerIcon: {
            type: String,
            default: ''
        },
        disableDots: {
            type: Boolean,
            default: false
        },
        maxLength: {
            type: Number,
            default: null,
        },
        centeredValue: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        forceValue: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        bolderLabel: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        solo: {
            type: Boolean,
            default: true
        },
        customKeypress: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            model: '',
        }
    },
    computed: {
        defaultValue() {

            const vm = this
            if (vm.inputMode === 'numeric' && !vm.disableDots) {
                if (vm.model === '' || vm.model === null || vm.model === undefined) return ''
                return vm.$options.filters.number(vm.model)
            }

            return vm.model

        }
    },
    methods: {
        focus() {
            const vm = this
            console.log('focus', vm.$refs['baseInput'])
            vm.$refs['baseInput'].focus()
        },
        onChange(value) {

            const vm = this
            if (!value) return vm.model = ''

            if (vm.inputMode === 'numeric' && !vm.disableDots) {
                return vm.model = Number(value.toString().replace(/\./g, ''))
            }

            return vm.model = value

        },
        setDefaults() {
            const vm = this
            if (vm.value || vm.forceValue) {
                vm.model = vm.value
            }
        },
        reset() {
            const vm = this
            vm.model = ''
        },
        isNumber(event) {
            const vm = this
            if (vm.customKeypress) return vm.$emit('keypress', event)
            if (vm.inputMode !== 'numeric') return
            var charCode = event.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                event.preventDefault();
            } else {
                return true;
            }
        }
    },
    mounted() {
        var vm = this
        vm.setDefaults()
    },
    watch: {
        value(val) {
            this.setDefaults()
        },
        model(val) {
            this.$emit('change', val)
        }
    }
}
</script>

<style scoped>

.label {
    display: block;
    font-size: var(--fs-label);
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    margin-bottom: 6px;
}

.centered-input ::v-deep input {
    text-align: center;
    font-weight: bold;
}

.bolder {
    font-weight: 700;
}

</style>